import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import CustomCoinCard from "../../components/CustomCoinCard";
import Loader from "../../components/Loader";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import Footer from "../../components/Footer.jsx";
import "./Products.css";
import { useDispatch, useSelector } from "react-redux";
import { portfolioApi } from "../../redux/features/portfolio/portfolioSlice.js";
import axiosInstance from "../../utils/axiosInstance.js";

const Products = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { goldProducts, silverProducts } = t("productsPage");

  const location = useLocation();
  const isGold = location.pathname.includes("gold");

  let coinData = [];
  const metaltype = location?.pathname?.includes("gold") ? "gold" : "silver";

  const [loading, setLoading] = useState(false);

  const Token = sessionStorage.getItem("token");

  const [viewproduct, setviewproduct] = useState(true);

  const [sumdata, setSumdata] = useState([]);

  const [sortedSilverCoins, setSortedSilverCoins] = useState([]);

  const { data, loading: portLoading } = useSelector(
    (state) => state.portfolioSlice
  );

  // AUGMONT=========
  const { balQuantity: augGoldBalance } = data?.[0]?.augmont?.gold || {};

  const { balQuantity: augSilverBalance } = data?.[0]?.augmont?.silver || {};

  useEffect(() => {
    callAPI();
    dispatch(portfolioApi());
  }, []);

  const callAPI = async () => {
    setLoading(true);
    try {
      // const url = `${process.env.REACT_APP_BASE_URL}/augmont/products?page=1&count=30`;
      // const headers = {
      //   "Content-Type": "application/json",
      //   Accept: "application/json",
      //   Authorization: `Bearer ${Token}`,
      // };

      // const response = await fetch(url, {
      //   method: "GET",
      //   headers: headers,
      // });

      // const data = await response.json();

      const res = await axiosInstance.get("/augmont/products?page=1&count=30");
      // coinData = res.data;

      console.log("res=======>>>", res);

      const goldCoins =
        res?.data?.data[0]?.result?.data?.filter(
          (item) => item.metalType === "gold"
        ) || [];

      const sortedGoldCoins = goldCoins.sort(
        (a, b) => parseFloat(a.productWeight) - parseFloat(b.productWeight)
      );

      setSumdata(sortedGoldCoins);

      //-----------------------SORT SILVER COINS-------------------------------

      const silverCoins =
        res?.data?.data[0]?.result?.data?.filter(
          (item) => item.metalType === "silver"
        ) || [];

      const sortedSilverCoins = silverCoins.sort(
        (a, b) => parseFloat(a.productWeight) - parseFloat(b.productWeight)
      );

      setSortedSilverCoins(sortedSilverCoins);
    } catch (error) {
      console.error("Error connecting to API", error);
    } finally {
      setLoading(false);
    }
  };

  const [particulardata, setparticulardata] = useState(null);

  const handleCoinClick = (item) => {
    setparticulardata(item);
    setviewproduct(false);
  };

  return (
    <>
      {viewproduct ? (
        <div className="rounded">
          <div className="row mx-auto d-flex justify-content-center">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
                marginTop: "1rem",
                textAlign: "center",
              }}
            >
              <h2>{metaltype === "gold" ? goldProducts : silverProducts}</h2>
              <div>
                {metaltype === "gold" ? "Gold" : "Silver"} in Locker:{" "}
                {metaltype === "gold" ? augGoldBalance : augSilverBalance} gm
              </div>
            </div>

            <div style={{ marginBottom: "1.5rem" }}>
              <strong>Note: </strong> {metaltype === "gold" ? "Gold" : "Silver"}{" "}
              coins can be purchased only if sufficient{" "}
              {metaltype === "gold" ? "gold" : "silver"} is in the locker.
            </div>
            {loading ? (
              <div style={{ height: "50vh" }}>
                <Loader />
              </div>
            ) : (
              <div className="coin-products-container">
                {(metaltype === "gold" ? sumdata : sortedSilverCoins).map(
                  (item, index) => (
                    <Link
                      // to="/dashboard/productDetails"
                      to={`/dashboard/${isGold ? "gold" : "silver"}/delivery/${
                        item?.sku
                      }`}
                      key={index}
                      style={{
                        boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        cursor: "pointer",
                        width: "100%",
                        borderRadius: "5px",
                        padding: "8px",
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "column",
                      }}
                      state={item}
                    >
                      <div>
                        <CustomCoinCard
                          img={item?.productImages?.[0]?.url}
                          qty={item?.productWeight}
                          name={item?.name}
                          price={item?.basePrice}
                          click={() => {
                            handleCoinClick(item);
                          }}
                          isGold={isGold}
                          purity={item.purity}
                        />
                      </div>
                      <Button
                        fullWidth
                        variant="outlined"
                        sx={{
                          color: "#da2128",
                          borderColor: "#da2128",
                          "&:hover": {
                            backgroundColor: "#da2128",
                            color: "white",
                            borderColor: "#da2128",
                          },
                        }}
                      >
                        Buy Now
                      </Button>
                    </Link>
                  )
                )}
              </div>
            )}
            <Footer metalType={metaltype == "gold" ? "Gold" : "Silver"} />
          </div>
        </div>
      ) : (
        <>{/* <CoinDetial data={particulardata} /> */}</>
      )}
    </>
  );
};

export default Products;
